var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPerson(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 11,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.5 5.5a2.75 2.75 0 100-5.5 2.75 2.75 0 000 5.5zm1.925.688h-.359a3.744 3.744 0 01-3.132 0h-.359A2.888 2.888 0 00.687 9.075v.894c0 .57.462 1.031 1.032 1.031H9.28c.57 0 1.031-.462 1.031-1.031v-.894a2.888 2.888 0 00-2.887-2.887z",
    fill: "#fff"
  })));
}
export default SvgPerson;